var map = {
	"./agua.png": "3bb3",
	"./bebida.png": "19e5",
	"./botellas.png": "ca08",
	"./cafe.png": "809e",
	"./cerveza.png": "e5fe",
	"./cocinero.png": "fc38",
	"./combinado.png": "780e",
	"./cubiertos.png": "9bee",
	"./desayuno.png": "d70c",
	"./hamburguesa.png": "27d8",
	"./martini.png": "bf31",
	"./pan.png": "5ac0",
	"./pastel.png": "3f58",
	"./platoCombinado.png": "b090",
	"./sandwich.png": "b849",
	"./undefined.png": "0318"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "0330";